import { render } from "./OnetoFiveImageDivMehrfach.vue?vue&type=template&id=09f780e2&scoped=true&ts=true"
import script from "./OnetoFiveImageDivMehrfach.vue?vue&type=script&lang=ts"
export * from "./OnetoFiveImageDivMehrfach.vue?vue&type=script&lang=ts"

import "./OnetoFiveImageDivMehrfach.vue?vue&type=style&index=0&id=09f780e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f780e2"]])

export default __exports__